export default "__VITE_ASSET__$0aZJ8Xu__"